import axios from "axios";
import LRU from "lru-cache";
import useAxios, { configure } from "axios-hooks";

configure({
  axios: axios.create({ baseURL: "/wp-json/v1" }),
  cache: new LRU({ max: 10 })
});

// const timestamp = Date.now();

export const useApi = (url, ...config) => {
  // if (url.includes("?")) url += `&${timestamp}`;
  // else url += `?${timestamp}`;

  return useAxios(url, ...config);
};

export default useApi;